import ScanReview from './ScanReview';

export default ScanReview;
